<template>
  <div id="app" :class="{touch}">
    <router-view/>
    <simple-msg-popup />
  </div>
</template>
<script>
import SimpleMsgPopup from './views/components/SimpleMsgPopup.vue';

export default {
  name: 'App',
  components: { SimpleMsgPopup },
  watch: {
    $route() {
      this.$store.commit('setSite', this.site);
    },
  },
  data() {
    return {
      touch: false,
    };
  },
  created() {
    // const loc = window.location;
    // const org = loc.pathname.replace(/\/(kcl|ktc|ktr|kilt|fiti)?.*/i, '$1');
    // if (loc.hostname !== 'localhost' && org && loc.host.split('.')[0] !== org) {
    //   loc.href = `https://${org}.ksnara.net${loc.pathname}`;
    // }
    if ('ontouchstart' in window) this.touch = true;
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue